import { h, Component } from 'preact';
import Beans3 from '@/beans';
import { i18n, Utils } from '@/base/helpers';
import { ActionModalHeader } from '../../components';

const padNumber = (num) => String(num).padStart(2, '0');

export default class BirthDate extends Component {
  constructor(props) {
    super(props);
    const currentYear = new Date().getFullYear();

    this.years = Array.from({ length: currentYear - 1905 }, (_, i) => currentYear - i);
    this.days = Array.from({ length: 31 }, (_, i) => i + 1);

    this.state = {
      account: {},
      birthDay: '01',
      birthMonth: '01',
      birthYear: currentYear.toString(),
      status: '',
      statusColor: Utils.BeansStatusColor.default.color,
    };
  }

  componentDidMount() {
    Beans3.get({ path: 'ultimate/account/current' }).then((account) => {
      this.setState({ account });
      if (account.birthday) {
        const [year, month, day] = account.birthday.split('-');
        this.setState({
          birthDay: day,
          birthMonth: month,
          birthYear: year,
        });
      }
    });
  }

  onChanges = (key, value) => {
    this.setState({ [key]: value });
  };

  onSave = () => {
    const { birthDay, birthMonth, birthYear } = this.state;

    this.setState({
      status: i18n.t('settings', 'saving_settings'),
      statusColor: Utils.BeansStatusColor.loading.color,
    });

    Beans3.put({
      path: 'ultimate/account/current',
      data: { birthday: `${birthYear}-${birthMonth}-${birthDay}` },
    })
      .then((account) => {
        this.setState(
          {
            account,
            status: i18n.t('settings', 'settings_saved'),
            statusColor: Utils.BeansStatusColor.done.color,
          },
          () => {
            this.props.onClose(4000);
          }
        );
      })
      .catch((error) => {
        this.setState({
          status: Utils.getErrors(error),
          statusColor: Utils.BeansStatusColor.error.color,
        });
      });
  };

  renderMonthOptions() {
    const { month } = i18n._Strings;
    const { birthMonth } = this.state;

    return Object.keys(month).map((monthKey, index) => {
      const monthNum = index + 1;
      return (
        <option key={monthKey} value={padNumber(monthNum)} selected={monthNum === parseInt(birthMonth, 10)}>
          {i18n.t('month', monthKey)}
        </option>
      );
    });
  }

  render() {
    const { birthDay, birthMonth, birthYear, status, statusColor } = this.state;

    return (
      <div id="liana-modal-BirthDate" className="liana-rule-action-modal">
        <ActionModalHeader
          headerTitle={i18n.t('settings', 'birth_date')}
          closeTab={this.props.onClose}
          color="#273043"
        />
        <div className="liana-action-modal-body">
          <div className="liana-modal-body-content-wrapper">
            <div className="beans-text">{i18n.t('settings', 'birth_date')}</div>
            <div className="liana-modal-select-group">
              <select
                id="birth_month"
                className="liana-modal-BirthDateInput"
                value={birthMonth}
                onChange={(e) => this.onChanges('birthMonth', e.target.value)}
              >
                {this.renderMonthOptions()}
              </select>
              <select
                id="birth_day"
                className="liana-modal-BirthDateInput"
                value={birthDay}
                onChange={(e) => this.onChanges('birthDay', padNumber(e.target.value))}
                style={{ maxWidth: '90px' }}
              >
                {this.days.map((day) => (
                  <option key={day} value={padNumber(day)}>
                    {padNumber(day)}
                  </option>
                ))}
              </select>
              <select
                id="birth_year"
                className="liana-modal-BirthDateInput"
                value={birthYear}
                onChange={(e) => this.onChanges('birthYear', e.target.value)}
                style={{ maxWidth: '100px' }}
              >
                {this.years.map((year) => (
                  <option key={year} value={year}>
                    {year}
                  </option>
                ))}
              </select>
            </div>

            <div className="beans-text-secondary">{i18n.t('settings', 'birth_date_once')}</div>
            <div className="beans-button beans-button-primary" onClick={this.onSave}>
              {i18n.t('settings', 'save')}
            </div>
            {status && (
              <div className="beans-text" style={{ color: statusColor }}>
                {status}
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
}
